import { createContext } from 'react'

/** Form 把提交中态传给内部 `type="submit"` 的 Button，以及嵌套的 Dialog/Modal 关闭策略。 */
type FormSubmitContextValue = {
  pending: boolean
  /** 只有声明 lockAfterSuccess 的表单成功后才为 true；默认表单恒为 false，提交钮请求一结束就放开。 */
  lockedAfterSuccess: boolean
  error: string | null
  idempotencyKey: string | undefined
}

export const FormSubmitContext = createContext<FormSubmitContextValue | null>(null)

/** Dialog/Modal 收集子树里 Form 的 pending，供 closePolicy=not-while-pending 使用。 */
type OverlayPendingContextValue = {
  pending: boolean
  setChildPending: (pending: boolean) => void
}

export const OverlayPendingContext = createContext<OverlayPendingContextValue | null>(null)
